// extracted by mini-css-extract-plugin
export default {"spokeArticle":"spokeArticle__f5YeT","category":"category__s-MR4","bottomline":"bottomline__wDLOA","listened":"listened__nQLWW","box":"box__lAksg","flex":"flex__k4jyp"};